import { Component, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AccountService } from '@wb/core/services/account.service';
import { UserService } from '@wb/core/services/user.service';
import { Account } from '@wb/core/interfaces/account';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

interface ImportDialogData {
  columns: string[];
  title?: string;
}

@Component({
  selector: 'app-import-dialog',
  templateUrl: './import-dialog.component.html',
  styleUrls: ['./import-dialog.component.sass'],
})
export class ImportDialogComponent implements OnInit {
  emitCloneEvent = new EventEmitter<any[]>();

  emitLoadingEvent = new EventEmitter<string>();

  @ViewChild('#import-dialog') importRef?: MatDialogRef<any>;

  @ViewChild('#warning') warningRef?: MatDialogRef<any>;

  dataSource = new MatTableDataSource<any>();

  selection = new SelectionModel<any>(true, []);

  columns: string[] = [];

  isLoading = false;

  showWarning = false;

  formGroup: FormGroup = new FormGroup({
    account: new FormControl(),
    selectedImports: new FormControl(),
  });

  title: string = '';

  isError = false;

  selectedAccountUid = '';

  accounts: Account[] = [];

  filteredAccounts: Account[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImportDialogData,
    public dialogRef: MatDialogRef<ImportDialogComponent>,
    public user: UserService,
    private account: AccountService,
    public readonly dialog: MatDialog,
  ) {}

  async ngOnInit() {
    this.title = this.data.title ?? 'Import Data';
    this.columns = this.data.columns ?? [];
    this.account.accounts.subscribe((accounts: Account[]) => {
      this.accounts = accounts;
      this.filteredAccounts = accounts;
    });
  }

  //when you change the account, fetch the data and setup the columns
  async onSelectionChange(event: any) {
    this.isLoading = true;
    this.selection.clear();
    this.selectedAccountUid = event.value;
    this.emitLoadingEvent.emit(event.value);
  }

  onSubmit() {
    this.showWarning = true;
  }

  onWarningCancel() {
    this.showWarning = false;
  }

  onSave() {
    this.emitCloneEvent.emit(this.selection.selected);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
}
